import React from 'react'
import { Dashboard } from '@components/custom'
import './Comps.scss'
import { Loading } from '@components/common'
import { compose } from 'ramda'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import CompsEngine from '@engine/comps'

export class Comps extends React.Component {
  constructor(props) {
    super(props)
    this.forceTimeout = null
    this.state = {
      errorOnDrop: false,
      errorMessage: ''
    }
  }

  componentDidMount() {
    // Hack to force update of refs in the case of browser refreshs
    this.forceTimeout = setTimeout(() => this.forceUpdate(), 1)
  }

  componentWillUnmount() {
    clearTimeout(this.forceTimeout)
  }

  dropRejectHandler = (errOnDrop, errMessage) => {
    this.setState({ ...this.state, errorOnDrop: errOnDrop, errorMessage: errMessage, listInfoLoading: '' })
  }

  render() {
    const { loading } = this.props

    return (
      <Loading isLoading={loading}>
      <div data-testid="comps" className="comps-page">
        <Dashboard errorOnFileDrop={this.state} dropRejectHandler={this.dropRejectHandler}/>
      </div>
      </Loading>
    )
  }
}

Comps.propTypes = {
  loading: PropTypes.bool,
  isPopupDialogOpen: PropTypes.func,
  history: PropTypes.shape({
    push: PropTypes.func
  }),
  resetflag: PropTypes.bool,
  clearComps: PropTypes.func
}

const mapStateToProps = state => ({
  loading: CompsEngine.selectors.network.isLoading(
    state,
    CompsEngine.constants.SET_COMPS.ACTION
  ),
  resetflag: CompsEngine.selectors.comps.resetflag(state)
})

const mapDispatchToProps = {
  isPopupDialogOpen: CompsEngine.actions.isPopupDialogOpen,
  clearComps: CompsEngine.actions.clearComps
}

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(Comps)
